// = Libs =
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { SWRConfig } from 'swr';

// = Imports =
import App from './app/app';
import '@/styles/main.scss';
import SWR_CONFIG from '@/constants/swr-config';

ReactDOM.render(
  <SWRConfig value={SWR_CONFIG}>
    <Router>
      <App />
    </Router>
  </SWRConfig>,
  document.getElementById('root')
);
